import React from 'react';

import { parseQuizHtml } from '@/features/Quiz/utils/parseQuizHtml';

type QuizHtmlProps = {
    html?: string | null;
    className?: string;
    as?: keyof JSX.IntrinsicElements;
};

/** Renders sanitized quiz HTML with LaTeX preserved for MathJax. */
export function QuizHtml({ html, className, as: Tag = 'div' }: QuizHtmlProps) {
    return <Tag className={className}>{parseQuizHtml(html ?? '')}</Tag>;
}

export default QuizHtml;
